import { DEFAULT_SLIDE_MASTER, Slide } from '@features/powerpoint';
import { images } from './incrementality-matters/images';
import { shapes } from './incrementality-matters/shapes';
import { texts, attributionText } from './incrementality-matters/texts';

type IncrementalityMattersSlideProps = {
  liftText: string;
};

export const incrementalityMattersSlide = (
  props: IncrementalityMattersSlideProps
): Slide => {
  return {
    slideMaster: DEFAULT_SLIDE_MASTER,
    texts: [...texts, attributionText(props.liftText)],
    shapes,
    images,
  };
};
